<template>
    <div class="agx-add-to-cart-wrap">
        <Loading :show="isLoading"></Loading>
        <div :style="{ display: showAlert ? 'block' : 'none' }">
            <div class="cart-alert-box">
                <h3 v-if="!isError"><span class="glyphicon glyphicon-ok-circle" style="color:green;"> {{ alertMsg }} </span></h3>
                <h3 v-else><span class="glyphicon glyphicon-remove-circle" style="color:red;"> {{ alertMsg }} </span></h3>

                <div class="row">
                    <div class="col-xs-6">
                        <router-link class="btn btn-default" to="/Cart" v-if="hasLogin"><span
                                class="glyphicon glyphicon-shopping-cart"></span> {{ lang.itemDetail.cart }}</router-link>
                        <router-link class="btn btn-default" to="/wishList" v-if="!hasLogin"><span
                                class="glyphicon glyphicon-shopping-cart"></span> {{ lang.navi.wishList }}</router-link>
                    </div>
                    <div class="col-xs-6">
                        <span class="act-close-btn btn btn-default"
                            @click="showAlert = false">{{ lang.itemDetail.continue }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="cart-panel">
            <div style="text-align:right; margin-bottom:10px;">
                <span v-if="hasLogin" class="btnAddToCart btn agx-theme-bg" @click="addItemToCart">
                    {{ lang.common.addToCart }}
                </span>
                <span v-else class="btnAddToCart btn agx-theme-bg" @click="addItemToCart">
                    {{ lang.common.addToWishList }}
                </span>
            </div>
            <div>
                <div v-if="title !== null" class="cart-title">{{ title }}</div>
                <div v-if="selectedProps && selectedProps.length > 0" style="margin-top:6px;">
                    <span v-for="p in selectedProps" class="cart-label-inline">{{ p.name }}</span>
                </div>
            </div>
            <hr />
            <div>
                <div class="row" style="margin-bottom: 10px;">
                    <div class="col-xs-6">
                        <div class="cart-label">{{ lang.common.price }} <span>({{ currency }})</span></div>
                        <div class="form-control cart-price-value">
                            <span v-if="priceItem !== null">{{ priceItem.price }} </span>
                        </div>
                    </div>
                    <div class="col-xs-6" v-if="needItemQuant">
                        <div class="cart-label">{{ lang.common.quant }}</div>
                        <input type="text" class="form-control" placeholder="Quantity" v-model="quant">
                    </div>
                </div>

                <div class="row" v-if="itemProps !== null">
                    <div v-for="grp in itemProps" class="col-xs-12" style="margin-bottom:12px;">
                        <div class="cart-label">{{ grp.parent.name }}</div>
                        <div>
                            <span v-for="childProp in grp.childs"
                                class="cart-prop-btn"
                                :class="{ 'cart-prop-btn-selected': selectedProps && (selectedProps.filter(i => i.catId === childProp.catId).length > 0) }"
                                @click="propClicked(grp, childProp)">
                                <span class="glyphicon glyphicon-tag"
                                    v-if="selectedProps && (selectedProps.filter(i => i.catId === childProp.catId).length > 0)"></span>
                                {{ childProp.name }}
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import algo from "../utl/algo.js";
import Loading from './base/Loading.vue';

export default {
    components: {
        Loading: Loading
    },
    computed: {
        apiClient: function () {
            return this.mxnAgxApi.detailApiClient;
        },
        currency: function () {
            return this.$store.getters.configs.currency;
        },
        itemPageMsgs: function () {
            var shopNews = this.$store.getters.configs.shopNews;
            if (shopNews !== null && shopNews.length > 0) {
                return shopNews.filter((news) => { return news.msgType === "1"; });
            }
            return [];
        },
        lang: function () {
            return this.$store.getters.lang;
        },
        hasLogin: function () {
            return this.$store.getters.account !== null;
        },
        needItemQuant:function(){
            return this.$store.getters.shopConfigs.needItemQuant;
        }
    },
    props: ["postId", "title"],
    methods: {
        loadItem: function () {
            this.apiClient.getPricesPrms(this.postId).then((ret) => {
                console.log('item props', ret);

                if (ret.length === 0) return;
                if (ret.length === 1) {
                    this.priceItem = ret[0];
                    return;
                }

                this.priceList = ret;

                var grped = algo.grouperFunc();
                grped.addList(ret);
                this.itemProps = grped.getData();
                console.log('get grped', this.itemProps);
                this.itemProps = this.itemProps;

            });
        },
        propClicked: function (grp, prop) {
            console.log('grp and prop', grp, prop);

            var propCounts = this.itemProps.length;
            console.log(propCounts);
            if (this.selectedProps === null) {
                this.selectedProps = [];
            }

            var hasReplaced = false;
            this.selectedProps.forEach((item, index) => {
                if (item.parentId === prop.parentId) {
                    hasReplaced = true;
                    this.selectedProps[index] = prop;
                }
            });
            if (!hasReplaced) {
                this.selectedProps.push(prop);
            }

            if (this.selectedProps.length === this.itemProps.length) {
                //all prop selected,show price
                var ret = [];
                this.selectedProps.forEach(function (item) {
                    ret.push(item.catId);
                });
                ret = ret.sort(function (a, b) {
                    return a - b;
                });
                var code = ret.join("x");
                this.priceList.forEach((item) => {
                    if (item.propCode === code) {
                        this.priceItem = item;
                    }
                });
            }

        },
        addItemToCart: function () {
            this.isError = false;
            this.alertMsg = "";
            if (this.priceItem === null) {
                this.alertMsg = this.lang.itemDetail.selectAllProperty;
                this.isError = true;
                this.showAlert = true;
                return;
            }
            var cartItem = {
                "priceId": this.priceItem.id,
                "quant": this.quant
            };
            this.apiClient.addToCartPrms(cartItem).then((ret) => {
                this.onItemAdded(ret);
            });
        },
        onItemAdded: function (data) {
            if (data.ok === true) {
                this.alertMsg = this.lang.common.success;
            } else {
                this.alertMsg = this.lang.common.fail;
                this.isError = true;
            }
            this.showAlert = true;
        }
    },
    data: function () {
        return {
            item: null,
            isLoading: false,
            showAlert: false,
            alertMsg: "",
            isError: false,
            priceItem: null,
            quant: 1,
            priceList: null,
            itemProps: null,
            selectedProps: null
        }
    },
    mounted: function () {
        this.loadItem();
    },
    destroyed: function () {

    }

}

</script>